import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { MonthlyTimesheetToExport, UserRole } from '../../types';
import { QUERY_KEYS } from '../constants';

async function fetchMonthlyTimesheetsToExport(
  userIds: string,
  timeRange: string,
  all: boolean,
  role?: UserRole
): Promise<MonthlyTimesheetToExport[]> {
  let url = `/monthly-timesheet?ids=${userIds}&months=${timeRange}`;
  if (all) {
    url = url + `&allStatuses=true`;
  }
  if (role) {
    url = url + `&role=${encodeURIComponent(role)}`;
  }
  const { data } = await Http.axios.get<MonthlyTimesheetToExport[]>(url);
  return data;
}

export const useMonthlyTimesheetsToExport = ({
  userIds,
  timeRange,
  all,
  enabled = true,
  role,
}: {
  userIds: string;
  timeRange: string;
  all?: boolean;
  enabled?: boolean;
  // Role-context of the requesting page (Accountant export / Admin approvals / OP or Proxy summary).
  role?: UserRole;
}) => {
  return useQuery(
    [QUERY_KEYS.MONTHLY_TIMESHEET_TO_EXPORT, userIds, timeRange, all, role],
    () => fetchMonthlyTimesheetsToExport(userIds, timeRange, all || false, role),
    {
      staleTime: Infinity,
      enabled: Boolean(timeRange && enabled),
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};

export const useInvalidateMonthlyTimesheetsToExport = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.MONTHLY_TIMESHEET_TO_EXPORT,
    });
  };
};
